import React, { useEffect } from "react";
import Zendesk from "react-zendesk";
import PropTypes from "prop-types";
import { getProfile } from "../../reducers";
import accountActions from "../../actions/accountActions";
import { useSelector, useDispatch } from "react-redux";

const ZENDESK_KEY = process.env.REACT_APP_ZENDESK_KEY;

function ZendeskWidget({ profile }) {
    const zdEmail = !!profile ? profile.email : "";
    const zdName = !!profile ? profile.firstName + " " + profile.lastName : "";

    // Categories - Help Guides, Tutorials
    const searchCategories = ["360000034165", "200535051"];

    // Sections
    // unused constants commented out to remove warnings
    // const sectionAppraisal = ['360000026258','360000026278'];
    // const sectionRostering = ['4419482532241','4419499260177'];
    // const sectionJobPlanner = ['360000074105','360000074085'];
    // const section360Feedback = ['360000160817','4419499281041'];
    // const sectionPortfolio = ['360000024577','360000024637'];
    // const sectionTraining = ['360000075329','4419499353873'];
    // const sectionCentric = ['360000074005','360000073985'];

    const settings = {
        color: {
            theme: "#077695",
        },
        offset: {
            horizontal: "200px",
            vertical: "32px",
        },
        chat: {
            title: {
                "*": "Live Chat",
                "en-US": "Live Chat.",
                "en-GB": "Live Chat",
                pl: "Czat na żywo",
            },
            fields: [
                { id: "name", prefill: { "*": zdName } },
                { id: "email", prefill: { "*": zdEmail } },
            ],
        },
        contactForm: {
            title: {
                "*": "Contact Us",
            },
            fields: [
                { id: "name", prefill: { "*": zdName } },
                { id: "email", prefill: { "*": zdEmail } },
            ],
        },
        helpCenter: {
            searchPlaceholder: {
                "*": "Search our Help guides",
                fr: "Cherchez dans le centre d'aide",
            },
            filter: {
                category: searchCategories.join(),
            },
        },
    };

    return <Zendesk defer zendeskKey={ZENDESK_KEY} {...settings} />;
}

ZendeskWidget.propTypes = {
    profile: PropTypes.object,
};

const ZendeskWidgetContainer = () => {
    const profile = useSelector(getProfile);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(accountActions.getProfile());
    }, [dispatch]);

    // if (!profile) return null; // replace with placeholder
    return <ZendeskWidget profile={profile} />;
};

export default ZendeskWidgetContainer;
